import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: "app-alert-dialog",
  templateUrl: "./alert-dialog.component.html",
  styleUrls: ["./alert-dialog.component.scss"],
  imports: [],
})
export class AlertDialogComponent {
  constructor(
    public config: DynamicDialogConfig,
    private ref: DynamicDialogRef
  ) {}

  reject() {
    this.ref.close();
  }
}
